export default function FinanceCharts() {
  const monthlyData = [
    { month: 'Jan', income: 1245000, expense: 832000 },
    { month: 'Feb', income: 1180000, expense: 795000 },
    { month: 'Mar', income: 1320000, expense: 880000 },
    { month: 'Apr', income: 1150000, expense: 760000 },
    { month: 'May', income: 1280000, expense: 845000 },
    { month: 'Jun', income: 1410000, expense: 920000 },
  ];

  const categoryData = [
    { category: 'Product Sales', amount: 850000, percentage: 68 },
    { category: 'Raw Materials', amount: 250000, percentage: 30 },
    { category: 'Salaries', amount: 180000, percentage: 22 },
    { category: 'Utilities', amount: 45000, percentage: 5 },
    { category: 'Marketing', amount: 75000, percentage: 9 },
  ];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
        <h3 className="text-lg font-bold text-gray-900 mb-6">Income vs Expenses (Last 6 Months)</h3>
        <div className="space-y-4">
          {monthlyData.map((data, index) => (
            <div key={index}>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-700">{data.month}</span>
                <div className="flex items-center gap-4 text-xs">
                  <span className="text-green-600">₹{(data.income / 1000).toFixed(0)}K</span>
                  <span className="text-red-600">₹{(data.expense / 1000).toFixed(0)}K</span>
                </div>
              </div>
              <div className="flex gap-2 h-8">
                <div
                  className="bg-green-500 rounded"
                  style={{ width: `${(data.income / 1500000) * 100}%` }}
                ></div>
                <div
                  className="bg-red-500 rounded"
                  style={{ width: `${(data.expense / 1500000) * 100}%` }}
                ></div>
              </div>
            </div>
          ))}
        </div>
        <div className="flex items-center justify-center gap-6 mt-6 pt-6 border-t border-gray-200">
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 bg-green-500 rounded"></div>
            <span className="text-sm text-gray-600">Income</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 bg-red-500 rounded"></div>
            <span className="text-sm text-gray-600">Expenses</span>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
        <h3 className="text-lg font-bold text-gray-900 mb-6">Category Breakdown</h3>
        <div className="space-y-4">
          {categoryData.map((data, index) => (
            <div key={index}>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-700">{data.category}</span>
                <span className="text-sm text-gray-600">₹{(data.amount / 1000).toFixed(0)}K</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-3">
                <div
                  className="bg-teal-600 h-3 rounded-full transition-all duration-500"
                  style={{ width: `${data.percentage}%` }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
